// ROLES
const SUPER_ADMIN_ROLE = 'SuperAdmin';
const SALES_ROLE = 'SalesRole';
const CPA_ROLE = 'CpaRole';

const EBICS_ADMIN_EMAILS = ['thomas.dubois@fygr.io'];

export default {
  ADMIN_GROUP_ROLE: [SUPER_ADMIN_ROLE],
  SALES_GROUP_ROLE: [SUPER_ADMIN_ROLE, SALES_ROLE],
  CPA_GROUP_ROLE: [SUPER_ADMIN_ROLE, SALES_ROLE, CPA_ROLE],
  EBICS_ADMIN_EMAILS,
};
